/*
 * Shown when Property Search is unavailable:
 * - Deal Sauce (pacemorby / astroflip): point to Deal Sauce 2.0
 * - PEP and all other non-Realeflow orgs: Property Search is retired
 */

import React from 'react'
import { Link as RouterLink } from 'react-router'
import { Button, Container, Typography, Box, Stack } from '@mui/material'
import withSession from '@/housefolios-components/Session/withSession'

const DEALSAUCE_2_0_URL = 'https://app.dealsauce.io'
const DEALSAUCE_LOGO = '/images/DealSauce-Logo-Tan.png'

export function PropertySearchUnavailablePage(props) {
  const member = String(
    props?.session?.me?.activeOrg?.member || '',
  ).toLowerCase()
  const isDealSauce = ['pacemorby', 'astroflip'].includes(member)

  if (!isDealSauce) {
    return (
      <Container maxWidth="sm" sx={{ py: { xs: 6, md: 10 } }}>
        <Box
          sx={{
            textAlign: 'center',
            borderRadius: 2,
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            px: { xs: 2.5, sm: 4 },
            py: { xs: 3.5, sm: 4.5 },
          }}
        >
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 700,
              fontSize: { xs: '1.5rem', sm: '1.85rem' },
            }}
          >
            Property Search is no longer available
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "text.secondary",
              mb: 3.5,
              maxWidth: 420,
              mx: 'auto',
              lineHeight: 1.6
            }}>
            Property Search has been retired. Continue managing properties
            from your portfolios and Launchpad.
          </Typography>
          <Button
            component={RouterLink}
            to="/launchpad"
            variant="contained"
            disableElevation
            sx={{ textTransform: 'none', fontWeight: 600 }}
          >
            Go to Launchpad
          </Button>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 6, md: 10 } }}>
      <Box
        sx={{
          textAlign: 'center',
          borderRadius: 3,
          overflow: 'hidden',
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          boxShadow: '0 8px 28px rgba(87, 19, 0, 0.08)',
        }}
      >
        <Box
          sx={{
            background:
              'linear-gradient(180deg, #6B1800 0%, #571300 100%)',
            px: 3,
            py: 3.5,
          }}
        >
          <Box
            component="img"
            src={DEALSAUCE_LOGO}
            alt="Deal Sauce"
            sx={{
              height: { xs: 56, sm: 72 },
              width: 'auto',
              maxWidth: '100%',
              objectFit: 'contain',
            }}
          />
        </Box>
        <Box sx={{ px: { xs: 2.5, sm: 4 }, py: { xs: 3.5, sm: 4.5 } }}>
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 700,
              color: '#571300',
              fontSize: { xs: '1.5rem', sm: '1.85rem' },
            }}
          >
            Property Search has moved to 2.0
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "text.secondary",
              mb: 3.5,
              maxWidth: 420,
              mx: 'auto',
              lineHeight: 1.6
            }}>
            Find properties, underwrite deals, and keep building in Deal
            Sauce 2.0 — the new home for Property Search.
          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1.5}
            sx={{
              justifyContent: "center",
              alignItems: "center"
            }}>
            <Button
              variant="contained"
              disableElevation
              href={DEALSAUCE_2_0_URL}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                borderRadius: '24px',
                px: 3,
                py: 1.25,
                minHeight: 44,
                background:
                  'linear-gradient(180deg, #6B1800 0%, #571300 100%)',
                color: '#F5E6D3',
                textTransform: 'none',
                fontWeight: 700,
                fontSize: '0.95rem',
                letterSpacing: '0.02em',
                boxShadow: '0 2px 8px rgba(87, 19, 0, 0.35)',
                border: '2px solid #4a0f00',
                '&:hover': {
                  background:
                    'linear-gradient(180deg, #7A1C00 0%, #631600 100%)',
                  boxShadow: '0 3px 12px rgba(87, 19, 0, 0.45)',
                },
              }}
            >
              Try Deal Sauce 2.0
            </Button>
            <Button
              component={RouterLink}
              to="/launchpad"
              variant="text"
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                color: '#571300',
                '&:hover': {
                  bgcolor: 'rgba(87, 19, 0, 0.06)',
                },
              }}
            >
              Stay on Launchpad
            </Button>
          </Stack>
        </Box>
      </Box>
    </Container>
  );
}

export default withSession(PropertySearchUnavailablePage)
